import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AuthService } from '../../service/AuthService';

const authService = new AuthService();

const initialState = {
  user: JSON.parse(localStorage.getItem(process.env.REACT_APP_USER_KEY)),
  status: 'idle',
  message: null,
  requiresTwoFactor: false,
  twoFactorEmail: null,
};

export const signinAsync = createAsyncThunk(
  'signin/credentials',
  async ({email, password, captchaToken}) => {
    return await authService.signin(email, password, captchaToken);
  }
);

export const verifyTwoFactorAsync = createAsyncThunk(
  'signin/verifyTwoFactor',
  async ({email, code}) => {
    return await authService.verifyTwoFactor(email, code);
  }
);

export const signinSlice = createSlice({
  name: 'signinSlice',
  initialState,
  reducers: {
    logout: (state) => {
      localStorage.removeItem(process.env.REACT_APP_USER_KEY);
      localStorage.removeItem(process.env.REACT_APP_TOKEN_KEY);
      state.user = null;
      state.requiresTwoFactor = false;
      state.twoFactorEmail = null;
    },
    resetTwoFactor: (state) => {
      state.requiresTwoFactor = false;
      state.twoFactorEmail = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signinAsync.pending, (state) => {
        state.message = null;
        state.status = 'loading';
      })
      .addCase(signinAsync.rejected, (state) => {
        state.status = 'idle';
        state.message = 'Usuário e/ou senha inválidos.';
      })
      .addCase(signinAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        if (!action.payload) {
          state.message = 'Usuário e/ou senha inválidos.';
        } else if (action.payload.requiresTwoFactor) {
          state.requiresTwoFactor = true;
          state.twoFactorEmail = action.meta.arg.email;
          state.message = null;
        }
      })
      .addCase(verifyTwoFactorAsync.pending, (state) => {
        state.message = null;
        state.status = 'loading';
      })
      .addCase(verifyTwoFactorAsync.rejected, (state) => {
        state.status = 'idle';
        state.message = 'Código inválido ou expirado.';
      })
      .addCase(verifyTwoFactorAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        if (!action.payload) {
          state.message = 'Código inválido ou expirado.';
        } else {
          state.message = null;
          state.requiresTwoFactor = false;
          state.twoFactorEmail = null;
          const user = {
            displayName: action.payload.displayName,
            email: action.payload.email,
          };
          localStorage.setItem(process.env.REACT_APP_USER_KEY, JSON.stringify(user));
          localStorage.setItem(process.env.REACT_APP_TOKEN_KEY, action.payload.stsTokenManager.accessToken);
          state.user = action.payload;
        }
      });
  },
});

export const { logout, resetTwoFactor } = signinSlice.actions;

export const selectMessage = (state) => state.signin.message;
export const selectUser = (state) => state.signin.user;
export const selectStatus = (state) => state.signin.status;
export const selectRequiresTwoFactor = (state) => state.signin.requiresTwoFactor;
export const selectTwoFactorEmail = (state) => state.signin.twoFactorEmail;

export default signinSlice.reducer;